export default __webpack_public_path__ + "static/experienceImg-f1feaf9573e749bd59ecee14c409137d.png";